export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}course/material-chapter-file`;

    return $resource(url, null, {
        getStatus: {
            method: 'GET',
            url: `${url}/status/:filenameHash`
        },
        getSlide: {
            method: 'GET',
            url: `${url}/:filenameHash/slide/:slideNumber`,
            transformResponse: (data) => {
                // Return raw HTML without JSON parsing
                return { html: data };
            }
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/MaterialFile/index.js